import styles from './notafical.module.css';
import ui from "../../styles/ui.module.css";
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { LuSearch } from "react-icons/lu";
import { FiSave, FiTrash2 } from "react-icons/fi";
import api from "../../services/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from '../../components/Spinner/carregando';
import useConfirmDialog from "../../components/ConfirmModal/useConfirmDialog.jsx";

// API centralizada via services/api

function Notafiscal() {
  const [isLoading, setIsLoading] = useState(false);
  const [taxasBloqueadas, setTaxasBloqueadas] = useState(true); // Para o input do tfoot
  const [vendasTotais, setVendasTotais] = useState({
    BRL: 0,
    BOB: 0,
    LBOB: 0,
    LBRL: 0,
    PBRL: 0,
    count: 0,
  });
  const [filtroVendas, setFiltroVendas] = useState({
    nf: 'Tudo',
  });
  const [botoesIndividual, setBotoesIndividual] = useState(false);
  const [filtrosDoVendas, setFiltrosDoVendas] = useState([]);
  const [editando, setEditando] = useState(null);
  // Estados de debug removidos: respostaPost, itemPost, chamaGet, contador
  const [dataList, setDataList] = useState([]);
  const [notaFiscTodas, setNotaFiscTodas] = useState('');
  const [notaFisc, setNotaFisc] = useState({
    ID: "",
    NF: "",
  });
  const [numeroNf, setNumeroNf] = useState({
    ID: "",
    NF: "",
  });
  const [formData, setFormData] = useState({
    data: "",
    compraBobDia: "",
    nomeBRL: "",
    nomeBOB: "",
    valorBRL: "",
    valorBOB: "",
  });
  // NFSe removida
  const [taxasMap, setTaxasMap] = useState({});
  const [exportReview, setExportReview] = useState({ open: false, issues: [], byNF: null, order: [] });
  const { confirm, ConfirmModal } = useConfirmDialog({
    confirmClassName: `${ui.butdesktop} ${ui.btnPrimary}`,
    cancelClassName: ui.butdesktop,
  });

  // Removidos: endereço padrão, parseSoapMessages e formulário NFSe
  const nomeFiltroRef = useRef(null);

  // Helpers de formatação para exportação ColetaNac
  const formatNumberBR = (num, decimals = 2) => {
    const n = Number(num || 0);
    const fixed = n.toFixed(decimals);
    return fixed.replace('.', ',');
  };
  const toDDMMYYYY = (iso) => {
    if (!iso) return '';
    const [y, m, d] = String(iso).split('-');
    if (!y || !m || !d) return '';
    return `${d}${m}${y}`;
  };
  const formatDateBR = (iso) => {
    if (!iso) return '';
    try { return new Date(`${iso}T00:00:00`).toLocaleDateString('pt-BR'); } catch { return iso; }
  };

  // Datas disponíveis de taxa (ordenadas)
  const taxaDates = React.useMemo(() => Object.keys(taxasMap || {}).filter(Boolean).sort(), [taxasMap]);
  const findNearestTaxa = (dateISO) => {
    let prev = null;
    let next = null;
    for (let i = 0; i < taxaDates.length; i++) {
      const d = taxaDates[i];
      if (d < dateISO) { prev = d; continue; }
      if (d === dateISO) return { prev: null, next: null };
      next = d; break;
    }
    return { prev, next };
  };

  // Prepara agrupamento por NF a partir dos itens filtrados
  const prepareByNF = () => {
    const items = Array.isArray(itensFiltradosOrdenados) ? itensFiltradosOrdenados : [];
    const byNF = new Map();
    items.forEach((it) => {
      const nf = Number(it?.NF || 0);
      if (!Number.isFinite(nf) || nf <= 0) return; // exporta apenas com NF
      const k = String(nf);
      const valorBRL = parseFloat(it?.VALORBRL || 0) || 0;
      const dataISO = String(it?.DATA || '');
      const nomeCli = (it?.NOME_CLIENTE || it?.NOMEBRL || '').replace(/\|/g, ' ').trim();
      const cpfCnpj = String(it?.CPF || '').replace(/\D/g, '');
      if (!byNF.has(k)) byNF.set(k, { totalBRL: 0, datas: new Map(), nomes: new Set(), cpfs: new Set() });
      const agg = byNF.get(k);
      agg.totalBRL += valorBRL;
      if (dataISO) agg.datas.set(dataISO, (agg.datas.get(dataISO) || 0) + valorBRL);
      if (nomeCli) agg.nomes.add(nomeCli);
      if (cpfCnpj) agg.cpfs.add(cpfCnpj);
    });
    const order = Array.from(byNF.keys()).sort((a, b) => Number(a) - Number(b));
    return { byNF, order };
  };

  useEffect(() => {
    // Carrega taxas de câmbio para o período atual
    (async () => {
      try {
        const { start, end } = getMonthRange();
        const dataInicio = filtrosDoVendas?.dataInicio || start;
        const dataFim = filtrosDoVendas?.dataFim || end;
        const resp = await api.get('/consultas-saldos/taxas', { params: { dataInicio, dataFim } });
        const list = Array.isArray(resp.data) ? resp.data : [];
        const map = {};
        list.forEach((t) => {
          const k = String(t.DATA || '').slice(0, 10);
          if (!k) return;
          map[k] = { BRL: parseFloat(t.BRL || 0) || 0, USD: parseFloat(t.USD || 0) || 0, BOB: parseFloat(t.BOB || 0) || 0 };
        });
        setTaxasMap(map);
      } catch (e) {
        console.warn('Falha ao carregar /consultas-saldos/taxas:', e?.message || e);
      }
    })();
  }, [filtrosDoVendas?.dataInicio, filtrosDoVendas?.dataFim]);

  const exportColetaNac = () => {
    try {
      const { byNF, order } = prepareByNF();
      // Pré-checagem de pendências de taxa
      const issues = [];
      for (const nf of order) {
        const agg = byNF.get(nf);
        if (!agg || agg.totalBRL <= 0) continue;
        let chosenDate = '';
        let maxVal = -1;
        agg.datas.forEach((sum, d) => { if (sum > maxVal) { maxVal = sum; chosenDate = d; } });
        const hasTax = !!(taxasMap[chosenDate] && (parseFloat(taxasMap[chosenDate].BRL || 0) > 0));
        if (!hasTax) {
          const { prev, next } = findNearestTaxa(chosenDate);
          issues.push({ nf, chosenDate, prev, next });
        }
      }

      if (issues.length > 0) {
        setExportReview({ open: true, issues, byNF, order });
        return;
      }

      // Sem pendências -> gerar
      const lines = [];
      for (const nf of order) {
        const agg = byNF.get(nf);
        if (!agg || agg.totalBRL <= 0) continue;
        let chosenDate = '';
        let maxVal = -1;
        agg.datas.forEach((sum, d) => { if (sum > maxVal) { maxVal = sum; chosenDate = d; } });
        const taxaBRL = parseFloat(taxasMap[chosenDate]?.BRL || 0) || 0;
        const quantidade = taxaBRL > 0 ? (agg.totalBRL / taxaBRL) : 0;
        const nome = Array.from(agg.nomes)[0] || '';
        const cpfCnpj = Array.from(agg.cpfs)[0] || '';
        const dataBR = toDDMMYYYY(chosenDate);
        const row = [
          '0120',
          dataBR,
          'I',
          formatNumberBR(agg.totalBRL, 2),
          '0,00',
          'USDT',
          formatNumberBR(quantidade, 8),
          '1',
          'BR',
          cpfCnpj,
          '',
          nome,
        ].join('|');
        lines.push(row);
      }

      if (!lines.length) { toast.warn('Nenhum dado para exportar com os filtros atuais.'); return; }
      lines.sort((a, b) => {
        const [_, dA, , , , , , , , , , nA] = a.split('|');
        const [__, dB, , , , , , , , , , nB] = b.split('|');
        if (dA !== dB) return dA.localeCompare(dB);
        return nA.toUpperCase().localeCompare(nB.toUpperCase(), 'pt-BR');
      });
      const content = lines.join('\r\n') + '\r\n';
      const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
      const start = (filtroVendas?.dataInicio || '').replace(/-/g, '');
      const end = (filtroVendas?.dataFim || '').replace(/-/g, '');
      const period = (start && end) ? `${start}-${end}` : (start || end || new Date().toISOString().slice(0,10).replace(/-/g,''));
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `ARQ_CRIPTO_0120_${period}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
      toast.success('Exportação gerada com sucesso.');
    } catch (e) {
      console.error('Falha ao exportar ColetaNac:', e);
      toast.error('Falha ao exportar arquivo.');
    }
  };

  const finalizeExportWithSelections = () => {
    try {
      const { byNF, order, issues } = exportReview || {};
      if (!byNF || !order) { setExportReview({ open: false, issues: [], byNF: null, order: [] }); return; }
      // Verifica escolhas
      for (const it of issues) {
        if (!it.selection || !['prev','next'].includes(it.selection)) {
          toast.warn('Selecione anterior ou posterior para todas as NFs sem taxa.');
          return;
        }
      }
      const selectionByNF = new Map(issues.map(it => [String(it.nf), it.selection === 'prev' ? it.prev : it.next]));

      const lines = [];
      for (const nf of order) {
        const agg = byNF.get(nf);
        if (!agg || agg.totalBRL <= 0) continue;
        let chosenDate = '';
        let maxVal = -1;
        agg.datas.forEach((sum, d) => { if (sum > maxVal) { maxVal = sum; chosenDate = d; } });
        let taxaBRL = parseFloat(taxasMap[chosenDate]?.BRL || 0) || 0;
        if (!taxaBRL && selectionByNF.has(String(nf))) {
          const altDate = selectionByNF.get(String(nf));
          taxaBRL = parseFloat(taxasMap[altDate]?.BRL || 0) || 0;
          if (!taxaBRL) { toast.error(`Taxa selecionada inválida para NF ${nf}.`); return; }
        }
        const quantidade = taxaBRL > 0 ? (agg.totalBRL / taxaBRL) : 0;
        const nome = Array.from(agg.nomes)[0] || '';
        const cpfCnpj = Array.from(agg.cpfs)[0] || '';
        const dataBR = toDDMMYYYY(chosenDate);
        const row = [
          '0120', dataBR, 'I',
          formatNumberBR(agg.totalBRL, 2), '0,00', 'USDT',
          formatNumberBR(quantidade, 8), '1', 'BR',
          cpfCnpj, '', nome,
        ].join('|');
        lines.push(row);
      }
      if (!lines.length) { toast.warn('Nenhum dado para exportar.'); return; }
      lines.sort((a, b) => {
        const [_, dA, , , , , , , , , , nA] = a.split('|');
        const [__, dB, , , , , , , , , , nB] = b.split('|');
        if (dA !== dB) return dA.localeCompare(dB);
        return nA.toUpperCase().localeCompare(nB.toUpperCase(), 'pt-BR');
      });
      const content = lines.join('\r\n') + '\r\n';
      const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
      const start = (filtroVendas?.dataInicio || '').replace(/-/g, '');
      const end = (filtroVendas?.dataFim || '').replace(/-/g, '');
      const period = (start && end) ? `${start}-${end}` : (start || end || new Date().toISOString().slice(0,10).replace(/-/g,''));
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `ARQ_CRIPTO_0120_${period}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
      setExportReview({ open: false, issues: [], byNF: null, order: [] });
      toast.success('Exportação gerada com sucesso.');
    } catch (e) {
      console.error('Falha ao finalizar exportação:', e);
      toast.error('Falha ao finalizar exportação.');
    }
  };

  // Helper mês atual (YYYY-MM-DD)
  const getMonthRange = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const toISO = (d) => d.toISOString().slice(0, 10);
    return { start: toISO(start), end: toISO(end) };
  };

  // Preenche datas padrão no primeiro render
  useEffect(() => {
    if (!filtroVendas.dataInicio || !filtroVendas.dataFim) {
      const { start, end } = getMonthRange();
      setFiltroVendas((prev) => ({ ...prev, dataInicio: start, dataFim: end }));
      setFiltrosDoVendas((prev) => ({ ...prev, dataInicio: start, dataFim: end, nomeFiltro: prev?.nomeFiltro || '' }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Carrega vendas ao alterar período aplicado
    getVendas();
  }, [filtrosDoVendas?.dataInicio, filtrosDoVendas?.dataFim]);


  const getVendas = async () => {
    try {
      setIsLoading(true);
      const { start, end } = getMonthRange();
      const dataInicio = filtrosDoVendas?.dataInicio || start;
      const dataFim = filtrosDoVendas?.dataFim || end;
      if (!filtrosDoVendas?.dataInicio || !filtrosDoVendas?.dataFim) {
        setFiltrosDoVendas((prev) => ({ ...prev, dataInicio, dataFim }));
        setFiltroVendas((prev) => ({ ...prev, dataInicio, dataFim }));
      }
      const resposta = await api.get("/nf", { params: { dataInicio, dataFim } });
      const dataComDisabled = (Array.isArray(resposta.data) ? resposta.data : []).map((item) => ({
        ...item,
        isDisabled: true,
      }));
      setDataList(dataComDisabled);
      toast.success("Vendas carregadas com sucesso!");
    } catch (erro) {
      if (erro?.message === 'Network Error') toast.error('Falha de conexão com o servidor.');
      else toast.warn('Não foi possível carregar os dados de NF.');
    } finally {
      setIsLoading(false);
    }
  } 

  // Atualização em lote com limitação de concorrência
  const updateManyNF = async (ids, valueToSave, batchSize = 15) => {
    for (let i = 0; i < ids.length; i += batchSize) {
      const slice = ids.slice(i, i + batchSize);
      await Promise.all(slice.map((ID) => api.put(`/nf/${ID}`, { nf: valueToSave })));
    }
  };

  const handleSalvar = async (id) => {
    setIsLoading(true)
    // limpeza de estados não utilizados removida


    /*let idEstraido = "";
    if(id.length) {
      setIsLoading(false)
      idEstraido = id[0].ID;
      setIsLoading(false)
    }*/
    //console.log("linha 96, função IF:", idEstraido)
    //console.log("linha 97, função HANDLESALVAR:", id)
    //console.log("linha 98, useState NotaFisc:", notaFisc)

    let itemToSave = null;
    if (!Array.isArray(id)) {
      itemToSave = dataList.find((item) => item.ID === id) || null;
      if (!itemToSave) {
        toast.error("Item não encontrado!");
        setIsLoading(false);
        return;
      }
    }

      let nfToSave = ""; 
      if(notaFisc.NOME === "NFTodos") {
        nfToSave = notaFisc.NF;
      } else {
        nfToSave = numeroNf.NF || (itemToSave ? itemToSave.NF : "");
      }
      

    try {
      setIsLoading(true)
      if(Array.isArray(id)) {
        const ids = id.map((x) => (typeof x === 'object' ? x.ID : x)).filter(Boolean);
        const valueToSave = parseInt(String(notaFiscTodas || '').replace(/\D/g,''), 10);
        if (Number.isNaN(valueToSave)) {
          toast.warn('Informe o número de NF no campo NF (Todos).');
        } else {
          await updateManyNF(ids, valueToSave);
          toast.success(`Atualizado ${ids.length} item(ns).`);
        }
      } else {
        const parsed = parseInt(String(nfToSave || '').replace(/\D/g,''), 10);
        if (Number.isNaN(parsed)) {
          toast.warn('Informe um número de NF válido.');
        } else {
          let resposta = await api.put(`/nf/${id}`, { nf: parsed });
          if (resposta.status === 200) {
            toast.success(`Venda com ID ${id} atualizada com sucesso!`);
          }
        }
      }

      //console.log("ln 192, respostaPost para multiplos envios:", respostaPost);
      //await getVendas();
      setEditando(null);
      setNumeroNf({ ID: "", NF: "" });
      // Recarrega a lista para refletir as alterações
      await getVendas();
      // Limpa apenas o campo de nome; mantém período e filtro NF
      setNotaFiscTodas("");
      setFiltroVendas((prev) => ({ ...prev, nomeFiltro: '' }));
      setFiltrosDoVendas((prev) => ({ ...prev, nomeFiltro: '' }));
    } catch (erro) {
      toast.error(`Erro: ${erro.response?.data || erro.response}`);
      console.error("Erro ao salvar venda:", erro);

      //await getVendas();
    } finally{
      setIsLoading(false)
    }
  };

  const validarNFParaSalvar = () => {
    const digits = String(notaFiscTodas || '').replace(/\D/g, '');
    const value = Number(digits);
    return digits && Number.isFinite(value) && value > 0;
  };

  const criarResumoConfirmacao = () => {
    const valor = notaFiscTodas || '';
    const linhas = itensFiltrados.slice(0, 5).map((item) => {
      const nome = item.NOME_CLIENTE || item.NOMEBRL || '—';
      const data = formatDateBR(item.DATA);
      return `${data} · ${nome} · NF atual: ${item.NF || '—'} · Valor BRL: ${item.VALORBRL?.toFixed ? item.VALORBRL.toFixed(2) : item.VALORBRL}`;
    });
    if (itensFiltrados.length > 5) {
      linhas.push(`...mais ${itensFiltrados.length - 5} venda(s)`);
    }
    return `Você está prestes a aplicar NF ${valor} em ${itensFiltrados.length} venda(s):\n${linhas.join('\n')}\n\nConfirma?`;
  };

  const handleSalvarComValidacao = async () => {
    if (!validarNFParaSalvar()) {
      toast.warn('Informe um número de NF válido antes de salvar.');
      return;
    }
    const confirmado = await confirm(criarResumoConfirmacao());
    if (!confirmado) return;
    await handleSalvar(itensFiltrados);
  };

  /*if(respostaPost.length) {
  console.log("ln 195, respostaPost para multiplos envios:", respostaPost);
  }*/
  const handleTaxaChange = (e, id) => {
    
    const { name, value } = e.target;
    const digits = String(value || '').replace(/\D/g, '');
    const parsedValue = parseInt(digits, 10) || 0;
    const nomeValue = name || "";
    //console.log("id função HANDLETAXACHANGE valor:", parsedValue)
    //console.log("id função HANDLETAXACHANGE nome:", nomeValue)

    setNotaFiscTodas(parsedValue);
    setNumeroNf((prev) => ({ ...prev, [name]: parsedValue, ID: id }));
    setNotaFisc({ NOME: nomeValue, NF: parsedValue });
    // Reflete o valor digitado na linha
    setDataList((prev) => Array.isArray(prev)
      ? prev.map((item) => item.ID === id ? { ...item, NF: parsedValue } : item)
      : prev
    );
  };

  // handletodasTaxaChange removido (feature desativada)

  const handleEdit = (id) => {
    if(id.length > 1) {
      setBotoesIndividual(!botoesIndividual);

      id.forEach((itemEdit) =>  {
        setDataList((prevDataList) =>
          prevDataList.map((item) =>
            item.ID === itemEdit.ID ? { 
              ...item, 
              isDisabled: !item.isDisabled } : item
          )
        ); 
        
        setEditando(id);   
      })

    }

    setDataList((prevDataList) =>
      prevDataList.map((item) =>
        item.ID === id ? { ...item, isDisabled: !item.isDisabled } : item
      )
    );



    setEditando(id);
  };

  // Fluxos NFSe (emitir/consultar/cancelar) removidos

  const handleDelete = async (idOrList) => {
    // Exclusão em lote (grupo)
    if (Array.isArray(idOrList)) {
      const items = idOrList || [];
      const itemsComNF = items.filter((x) => x && x.NF);
      if (itemsComNF.length === 0) {
        toast.warn('Nenhum item do grupo possui NF.');
        return;
      }
      const confirmacao = await confirm(
        `Tem certeza que deseja deletar a NF de ${itemsComNF.length} venda(s) deste grupo?`
      );
      if (!confirmacao) {
        toast.warn('Exclusão cancelada pelo usuário.');
        return;
      }
      try {
        setIsLoading(true);
        const results = await Promise.all(
          itemsComNF.map((it) =>
            api
              .delete(`/nf/${it.ID}`)
              .then(() => ({ ok: true }))
              .catch((err) => ({ ok: false, err }))
          )
        );
        const ok = results.filter((r) => r.ok).length;
        const fail = results.length - ok;
        if (ok) toast.success(`NF removida de ${ok} venda(s).`);
        if (fail) toast.error(`${fail} falha(s) ao remover.`);
        await getVendas();
      } catch (erro) {
        toast.error('Erro ao deletar NF em lote');
        console.error('Erro ao deletar NF em lote:', erro);
      } finally {
        setIsLoading(false);
      }
      return;
    }

    // Exclusão individual
    const nfParaDeletar = dataList.find((nfs) => nfs.ID === idOrList);
    if (!nfParaDeletar) {
      toast.error('Item não encontrado!');
      return;
    }
    if (nfParaDeletar.NF) {
      try {
        const confirmacao = await confirm(`
          Tem certeza que deseja deletar a NF: ${nfParaDeletar.NF} 
          da Venda: ${nfParaDeletar.ID}, 
          Cliente: ${nfParaDeletar.NOME_CLIENTE || nfParaDeletar.NOMEBRL}, 
          Data: ${nfParaDeletar.DATA}, 
          Valor: ${nfParaDeletar.VALORBRL} Reais, 
          Lucro: ${nfParaDeletar.LUCROBRL} Reais!
        `);

        if (!confirmacao) {
          toast.warn("Exclusão cancelada pelo usuário.");
          return;
        }
        setIsLoading(true);
        let resposta = await api.delete(`/nf/${idOrList}`);
        if(resposta.status === 200){
          toast.success(`NF removida com sucesso da Venda: ${nfParaDeletar.ID} !`);
        } else {
          toast.warn("Vish, deu zebra ao remover NF");
        }
        await getVendas();
      } catch (erro) {
        toast.error(`${erro}`);
        console.error("Erro ao deletar NF:", erro);
      } finally {
        setIsLoading(false);
      }
    } else {
      toast.warn(
        `Esta venda ${nfParaDeletar.ID}, Cliente: ${nfParaDeletar.NOME_CLIENTE || nfParaDeletar.NOMEBRL} não possui NF cadastrada!`
      );
    }
  };

  const filtroDataNomeCpf = (e) => {
    e.preventDefault();
    setFiltrosDoVendas(filtroVendas);
  };

  // Dblclick no nome: copia para filtro e aplica
  const aplicarFiltroPorNome = (nome) => {
    const valor = nome || '';
    setFiltroVendas((prev) => ({ ...prev, nomeFiltro: valor }));
    setFiltrosDoVendas((prev) => ({ ...prev, nomeFiltro: valor }));
    try { nomeFiltroRef.current?.focus?.(); } catch {}
  };

  const itensFiltrados = React.useMemo(() => {
    if (!Array.isArray(dataList)) return [];
    const di = filtrosDoVendas?.dataInicio || '';
    const df = filtrosDoVendas?.dataFim || '';
    const nomeFil = (filtrosDoVendas?.nomeFiltro || '').toUpperCase();
    const nfFiltro = filtrosDoVendas?.nf || 'Tudo';
    return dataList.filter((item) => {
      const d = item?.DATA || '';
      const nome = (item?.NOME_CLIENTE || item?.NOMEBRL || '').toUpperCase();
      const nfVal = Number(item?.NF || 0);
      const hasNF = Number.isFinite(nfVal) && nfVal > 0;
      if (di && d < di) return false;
      if (df && d > df) return false;
      if (nomeFil && !nome.includes(nomeFil)) return false;
      if (nfFiltro === 'Sem NF' && hasNF) return false;
      if (nfFiltro === 'Com NF' && !hasNF) return false;
      return true;
    });
  }, [dataList, filtrosDoVendas?.dataInicio, filtrosDoVendas?.dataFim, filtrosDoVendas?.nomeFiltro, filtrosDoVendas?.nf]);

  const itensFiltradosOrdenados = useMemo(() => {
    const arr = [...itensFiltrados];
    return arr.sort((a, b) => {
      const an = ((a.NOME_CLIENTE || a.NOMEBRL || '')).toUpperCase();
      const bn = ((b.NOME_CLIENTE || b.NOMEBRL || '')).toUpperCase();
      const byName = an.localeCompare(bn, 'pt-BR');
      if (byName !== 0) return byName;
      return (a.DATA || '').localeCompare(b.DATA || '');
    });
  }, [itensFiltrados]);

  // Agrupamento por NF (quando filtro = Com NF) ou por ID_CLIENTE; ordenado
  const grupos = useMemo(() => {
    const map = new Map();
    for (const it of itensFiltradosOrdenados) {
      const filterNF = (filtrosDoVendas?.nf || 'Tudo');
      const useNFGroup = filterNF === 'Com NF' && (it.NF && Number(it.NF) > 0);
      const groupKey = useNFGroup ? `NF:${it.NF}` : `CID:${it.ID_CLIENTE}`;
      if (!map.has(groupKey)) {
        map.set(groupKey, {
          key: groupKey,
          type: useNFGroup ? 'NF' : 'CLIENTE',
          nf: useNFGroup ? Number(it.NF) : null,
          idCliente: useNFGroup ? null : it.ID_CLIENTE,
          title: useNFGroup ? `NF ${it.NF}` : (it.NOME_CLIENTE || it.NOMEBRL || '—'),
          items: [],
          sumValorBRL: 0,
          sumLucroBRL: 0,
          sumTaxaDia: 0,
          cntTaxaDia: 0,
          sumPercBRL: 0,
          cntPercBRL: 0,
          cpfs: new Set(),
          nomes: new Set(),
        });
      }
      const g = map.get(groupKey);
      g.items.push(it);
      g.sumValorBRL += parseFloat(it.VALORBRL || 0);
      g.sumLucroBRL += parseFloat(it.LUCROBRL || 0);
      const taxa = parseFloat(it.TAXADIA);
      if (!Number.isNaN(taxa)) { g.sumTaxaDia += taxa; g.cntTaxaDia += 1; }
      const perc = parseFloat(it.PERCBRL);
      if (!Number.isNaN(perc)) { g.sumPercBRL += perc; g.cntPercBRL += 1; }
      if (it.CPF) g.cpfs.add(String(it.CPF));
      if (it.NOME_CLIENTE || it.NOMEBRL) g.nomes.add(String(it.NOME_CLIENTE || it.NOMEBRL));
    }
    const arr = Array.from(map.values());
    // compute helper derived fields and sort
    arr.forEach(g => {
      g.avgTaxaDia = g.cntTaxaDia ? (g.sumTaxaDia / g.cntTaxaDia) : 0;
      g.avgPercBRL = g.cntPercBRL ? (g.sumPercBRL / g.cntPercBRL) : 0;
      g.cpfUnique = (g.cpfs.size === 1) ? Array.from(g.cpfs)[0] : '';
      g.nomeUnique = (g.nomes.size === 1) ? Array.from(g.nomes)[0] : '';
      if (g.type === 'NF') {
        const firstName = g.items[0]?.NOME_CLIENTE || g.items[0]?.NOMEBRL || '';
        g.title = `NF ${g.nf} — ${g.nomeUnique || firstName || ''}`.trim();
      }
    });
    return arr.sort((a, b) => {
      // Sort NF groups by NF numeric, client groups by title (Nome)
      if (a.type === 'NF' && b.type === 'NF') return (a.nf || 0) - (b.nf || 0);
      if (a.type === 'CLIENTE' && b.type === 'CLIENTE') return a.title.toUpperCase().localeCompare(b.title.toUpperCase(), 'pt-BR');
      // mixed types: put client groups first by name, then NF by number
      if (a.type === 'CLIENTE' && b.type === 'NF') return -1;
      if (a.type === 'NF' && b.type === 'CLIENTE') return 1;
      return 0;
    });
  }, [itensFiltradosOrdenados, filtrosDoVendas]);

  const [expandedGroups, setExpandedGroups] = useState({});
  const toggleGroup = (key) => setExpandedGroups((p) => ({ ...p, [key]: !p[key] }));

  const calcularTotais = () => {
    const vTotais = itensFiltradosOrdenados.reduce(
      (acc, item) => {
        const percBRL = parseFloat(item.PERCBRL || 0);
        return {
          BRL: acc.BRL + parseFloat(item.VALORBRL || 0),
          BOB: acc.BOB + parseFloat(item.VALORBOB || 0),
          LBOB: acc.LBOB + parseFloat(item.LUCROBOB || 0),
          LBRL: acc.LBRL + parseFloat(item.LUCROBRL || 0),
          PBRL: acc.PBRL + percBRL,
          count: acc.count + (isNaN(percBRL) ? 0 : 1),
        };
      },
      { BRL: 0, BOB: 0, LBOB: 0, LBRL: 0, PBRL: 0, count: 0 }
    );

    setVendasTotais(vTotais);

  };

  useEffect(() => {
    calcularTotais();
  }, [dataList, filtrosDoVendas]);


  return (
    <main className={`${styles["nf-corpo"]} ${styles.root}`}>
      <ConfirmModal />
      <header className={styles["nf-header"]}>
        <div>
          <h3>Notas Fiscais Eletronicas de Serviços</h3>
          <p className={styles["nf-header-subtitle"]}>
            Visualize as vendas filtradas por periodos de data e por nome com nota fiscal ou sem nota fiscal.
          </p>
        </div>
        {/*<div className={styles["nf-header-actions"]}>
          <button
            type="button"
            onClick={exportColetaNac}
            title="Exportar arquivo ColetaNac Vendas (Sem Exchange)"
          >
            Exp. ColetaNac (TXT)
          </button>
        </div>*/}
      </header>

      {exportReview.open && (
        <div className={`${styles['nf-erroexport']} ${styles['nf-erroexport-backdrop']}`}>
          <div className={styles['nf-erroexport-card']} onClick={(e) => e.stopPropagation()}>
            <h4>Escolha de Taxas para NFs sem taxa no dia</h4>
            <p>Selecione para cada NF se deseja usar a taxa do dia anterior ou posterior ao dia escolhido.</p>
            <div className="tableScroll">
              <table className={styles['nf-erroexport-table']}>
                <thead>
                  <tr>
                    <th>NF</th>
                    <th>Data (original)</th>
                    <th>Anterior</th>
                    <th>Posterior</th>
                    <th>Selecionado</th>
                  </tr>
                </thead>
                <tbody>
                  {exportReview.issues.map((it, idx) => {
                    const prevTxt = it.prev ? `${it.prev} (BRL=${formatNumberBR(taxasMap[it.prev]?.BRL || 0, 2)})` : '—';
                    const nextTxt = it.next ? `${it.next} (BRL=${formatNumberBR(taxasMap[it.next]?.BRL || 0, 2)})` : '—';
                    return (
                      <tr key={`iss-${it.nf}-${idx}`}>
                        <td>{it.nf}</td>
                        <td>{it.chosenDate}</td>
                        <td>{prevTxt}</td>
                        <td>{nextTxt}</td>
                        <td>
                          <label className={styles["nf-radio-label"]}>
                            <input
                              type="radio"
                              name={`sel-${it.nf}`}
                              onChange={() => setExportReview((st) => ({ ...st, issues: st.issues.map((x) => x === it ? { ...x, selection: 'prev' } : x) }))}
                              disabled={!it.prev}
                            />
                            <span>Anterior</span>
                          </label>
                          <label className={styles["nf-radio-label"]}>
                            <input
                              type="radio"
                              name={`sel-${it.nf}`}
                              onChange={() => setExportReview((st) => ({ ...st, issues: st.issues.map((x) => x === it ? { ...x, selection: 'next' } : x) }))}
                              disabled={!it.next}
                            />
                            <span>Posterior</span>
                          </label>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className={styles["nf-erroexport-actions"]}>
              <button type="button" onClick={() => setExportReview({ open: false, issues: [], byNF: null, order: [] })}>Cancelar</button>
              <button type="button" onClick={() => finalizeExportWithSelections()}>Gerar arquivo</button>
            </div>
          </div>
        </div>
      )}

      <form className={styles["nf-filtrosDataNomeCpf"]} onSubmit={filtroDataNomeCpf}>
        <div className={`${styles["nf-filha"]} ${styles["filtroDataIni"]}`}>
          <label className={styles["nf-d-inicio1"]}>Data início</label>
          <input
            title='Insira a data INÍCIO do período a ser filtrado'
            name="dataInicio"
            type="date"
            value={filtroVendas.dataInicio || ''}
            onChange={(e) =>
              setFiltroVendas({
                ...filtroVendas,
                dataInicio: e.target.value || "",
              })
            }
          />
        </div>

        <div className={`${styles["nf-filha"]} ${styles["filtroDataFim"]}`}>
          <label className={styles["nf-d-fim1"]}>Data fim</label>
          <input
            title='Insira a data FIM do período a ser filtrado'
            type="date"
            name="dataFim"
            value={filtroVendas.dataFim || ''}
            onChange={(e) =>
              setFiltroVendas({ ...filtroVendas, dataFim: e.target.value || "" })
            }
          />
        </div>

        <div className={`${styles["nf-filha"]} ${styles["comNfe"]}`}>
          <label className={styles.nf1}>NF</label>
          <select
            title='Filtrar vendas com NF emitidas (Com NF)'
            name="nf"
            value={filtroVendas.nf || 'Tudo'}
            onChange={(e) =>
              setFiltroVendas({ ...filtroVendas, nf: e.target.value || "" })
            }
          >
            <option value="Tudo">Tudo</option>
            <option value="Com NF">Com NF</option>
            <option value="Sem NF">Sem NF</option>
          </select>
        </div>

        <div className={`${styles["nf-filha"]} ${styles["filtroNome"]}`}>
          <label>Nome</label>
          <input
            title='Insira o nome do cliente para filtrar'
            type="text"
            name="nomeFiltro"
            value={filtroVendas.nomeFiltro || ''}
            onChange={(e) =>
              setFiltroVendas({
                ...filtroVendas,
                nomeFiltro: e.target.value || "",
              })
            }
            ref={nomeFiltroRef}
          />
        </div>
        <div className={`${styles["nf-filha"]} ${styles["filtroBotao"]}`}>
          <label>&nbsp;</label>
          <button type="submit" className={`${ui.btn} ${ui.btnPrimary}`} title='Clique em FILTRAR ou pressione Enter para aplicar'>
            <p className={styles["nf-search-text"]}>Filtrar</p>
            <LuSearch className={styles["nf-search-svg"]} />
          </button>
        </div>
      </form>
{/*
      <section className={styles["nf-summary"]}>
        <div>
          <span>Total BRL</span>
          <strong>{formatNumberBR(vendasTotais.BRL, 2)}</strong>
        </div>
        <div>
          <span>Total Lucro BRL</span>
          <strong>{formatNumberBR(vendasTotais.LBRL, 2)}</strong>
        </div>
        <div>
          <span>Média %BRL</span>
          <strong>{formatNumberBR(vendasTotais.count > 0 ? vendasTotais.PBRL / vendasTotais.count : 0, 2)}%</strong>
        </div>
      </section>
*/}
      <section className={styles["nf-table-area"]}>
        <div className={styles["nf-table-wrapper"]}>
          {itensFiltradosOrdenados.length > 0 ? (
            <>
              <div className={styles["nf-toolbar"]} role="toolbar" aria-label="Ações em lote">
                
                <div className={styles["nf-toolbar-nftodos"]}>
                  <label htmlFor="nftodos-mobile">NF</label>
                  <input
                    id="nftodos-mobile"
                    name="NFTodos"
                    value={notaFiscTodas}
                    onChange={(e) => {
                      const digits = String(e.target.value || '').replace(/\D/g, '');
                      setNotaFiscTodas(digits);
                    }}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                </div >
                
                      <button
                        className={styles.salvarnfbtn}
                        type="button"
                        onClick={() => handleSalvarComValidacao()}
                      >
                    Salvar NF
                  </button>
                
              </div>
              <div className={`${styles["nf-table-scroll"]} tableScroll`}>
                <table className={styles["nf-tabela"]} border="1">
                  <caption className="sr-only">Vendas agrupadas por NF ou cliente</caption>
                  <thead>
                    <tr>
                      <th className={styles["col-compra"]}>Compra</th>
                      <th className={styles["col-data"]}>Data</th>
                      <th className={`${styles["col-nome"]} ${styles["nf-thnome"]}`}>Nome BRL</th>
                      <th className={styles["col-cpf"]}>CPF</th>
                      <th className={styles["col-valorbrl"]}>Valor BRL</th>
                      <th className={styles["col-taxadia"]}>Taxa do Dia</th>
                      <th className={styles["col-lucrobrl"]}>Lucro BRL</th>
                      <th className={styles["col-percbrl"]}>%BRL</th>
                      <th className={styles["col-nf"]}>NF</th>
                    </tr>
                  </thead>
                  <tbody>
                    {grupos.map((group) => {
                      const nfDisplay = String(group.nf ?? group.items?.[0]?.NF ?? '');
                      return (
                        <React.Fragment key={`grp-${group.key}`}>
                          <tr className={styles["nf-group-row"]}>
                            <td className={`${styles["col-compra"]} ${styles["nf-group-toggle"]}`} onClick={() => toggleGroup(group.key)} title="Clique para mostrar/ocultar vendas do grupo">
                              {expandedGroups[group.key] ? '▾' : '▸'} {group.items.length}x
                            </td>
                            <td className={styles["col-data"]}></td>
                            <td className={styles["col-nome"]} title='Duplo clique para filtrar por este nome'><strong>{group.title}</strong></td>
                            <td className={styles["col-cpf"]}>{group.cpfUnique}</td>
                            <td className={styles["col-valorbrl"]}><strong>{group.sumValorBRL.toFixed(2)}</strong></td>
                            <td className={styles["col-taxadia"]}><strong>{Number(group.avgTaxaDia || 0).toFixed(2)}</strong></td>
                            <td className={styles["col-lucrobrl"]}><strong>{group.sumLucroBRL.toFixed(2)}</strong></td>
                            <td className={styles["col-percbrl"]}><strong>{Number(group.avgPercBRL || 0).toFixed(2)}</strong></td>
                            <td className={styles["col-nf"]}>
                              <div className={styles["nf-cell"]}>
                                <span className={styles["nf-number"]}>{nfDisplay || 0}</span>
                                
                                <button
                                  className={styles["nf-removerbtn-todos"]}
                                  onClick={() => handleDelete(group.items)}
                                  type="button"
                                  aria-label="Remover NF deste grupo"
                                >
                                  <FiTrash2 size={15} />
                                </button>
                              </div>
                            </td>
                          </tr>
                          {expandedGroups[group.key] && group.items.map((item) => (
                            <tr key={item.ID}>
                              <td className={styles["col-compra"]}>{item.COMPRABOBDIA}</td>
                              <td className={styles["col-data"]}>{formatDateBR(item.DATA)}</td>
                              <td className={styles["col-nome"]} onDoubleClick={() => aplicarFiltroPorNome(item.NOME_CLIENTE || item.NOMEBRL)} title="Clique duas vezes para filtrar por este nome">{item.NOME_CLIENTE || item.NOMEBRL}</td>
                              <td className={styles["col-cpf"]}>{item.CPF}</td>
                              <td className={styles["col-valorbrl"]}>{item.VALORBRL.toFixed(2)}</td>
                              <td className={styles["col-taxadia"]}>{item.TAXADIA}</td>
                              <td className={styles["col-lucrobrl"]}>{item.LUCROBRL.toFixed(2)}</td>
                              <td className={styles["col-percbrl"]}>{item.PERCBRL.toFixed(2)}</td>
                              <td className={`${styles["col-nf"]} ${styles.tdnfe}`}>
                                {item.NF}
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                  <tfoot className="tabela-foot">
                    <tr className={styles["nf-trtotais"]}>
                      <td className={styles["col-compra"]}>Totais</td>
                      <td className={styles["col-data"]}></td>
                      <td className={styles["col-nome"]}></td>
                      <td className={styles["col-cpf"]}></td>
                      <td className={styles["col-valorbrl"]}>{vendasTotais.BRL.toFixed(2)}</td>
                      <td className={styles["col-taxadia"]}></td>
                      <td className={styles["col-lucrobrl"]}>{vendasTotais.LBRL.toFixed(2)}</td>
                      <td className={styles["col-percbrl"]}>
                        {(vendasTotais.count > 0 ? vendasTotais.PBRL / vendasTotais.count : 0).toFixed(2)}
                      </td>
                      <td className={`${styles["col-nf"]} ${styles.tdnfe}`}>
                        {/*<div className={styles.salvarbtn}>
                          <p className={styles["td-input-nfe"]}>
                            <input
                              name="NFTodos"
                              value={notaFiscTodas}
                              onChange={(e) => {
                                const digits = String(e.target.value || '').replace(/\D/g, '');
                                setNotaFiscTodas(digits);
                              }}
                              placeholder='Nº'
                            />
                          </p>
                          <button
                            className={styles.salvarnfbtn}
                            type="button"
                            onClick={() => handleSalvar(itensFiltrados)}
                          >
                            Salvar NF
                          </button>
                        </div>*/}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </>
            ) : (
              <p className={styles["nf-empty-state"]}>Nenhum dado armazenado...</p>
            )}
          </div>
          <div className={styles["nf-cards"]}>
            {itensFiltradosOrdenados.map((item) => (
              <div className={styles["nf-card"]} key={`nfc-${item.ID}`}>
                <div className={styles["nf-card-header"]}>
                  <span className={styles["nf-card-compra"]}>{item.COMPRABOBDIA}</span>
                  <span className={styles["nf-card-data"]}>{formatDateBR(item.DATA)}</span>
                </div>
                <div className={styles["nf-card-nome"]} onDoubleClick={() => aplicarFiltroPorNome(item.NOME_CLIENTE || item.NOMEBRL)} title="Clique duas vezes para filtrar por este nome">{item.NOME_CLIENTE || item.NOMEBRL}</div>
                <div className={styles["nf-card-cpf"]}>{item.CPF}</div>
                <div className={styles["nf-card-valores"]}>
                  <span className={styles["nf-card-brl"]}>BRL: {item.VALORBRL.toFixed(2)}</span>
                  <span className={styles["nf-card-lucro"]}>L: {item.LUCROBRL.toFixed(2)}</span>
                </div>
                <div className={styles["nf-card-nf"]}>
                  <label>NF:</label>
                  <input
                    name="NF"
                    value={item.NF ?? ''}
                    onChange={(e) => handleTaxaChange(e, item.ID)}
                    disabled={item.isDisabled}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                  <button className={styles["nf-card-removerbtn"]} onClick={() => handleDelete(item.ID)} aria-label={`Remover venda ${item.ID}`}>
                    <FiTrash2 size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>
      </section>

      <ToastContainer position="top-right" autoClose={3000} />
      <Spinner isLoading={isLoading} />
    </main>
  );
}

export default Notafiscal;
